import React from 'react';
import { FormattedMessage } from 'react-intl';
import { appNotification } from '../../containers/App/appNotification';
import { createLocalNotification } from '../../containers/App/utils';

const notification = createLocalNotification('AgentList', {
    error: (
        <FormattedMessage
            id='front-app/Agent/Notification/Error:title'
            defaultMessage='Agent Error'
        />
    ),
});

export const agentListNotifications = {
    unknownError: (details?: JSX.Element | string) => (
        notification.error(appNotification.texts.unknownError(details))
    ),
};
